@if (isConnected && !dropdownDisabled) {
  <div class="connected-rooms-dropdown-container" data-testid="connected-room-dropdown">
    <app-select
      class="connected-rooms-select-dropdown"
      [ngClass]="{ indicator: newVisualIndicators }"
      placeholder="Select a Room"
      [visualIndicators]="newVisualIndicators"
      [roomCounter]="selectedRoomCount"
      [(value)]="selectedRoomId"
    >
      @for (room of connectedRoomSet; track room.socialId) {
        <app-select-option
          [label]="room.name"
          [value]="room.socialId"
          [disabled]="isConnectedRoomFull(room)"
          (selected)="onRoomChange(room)"
          [hidden]="room.socialId === selectedRoomId"
        >
          @if (!!getRoomCount(room)) {
            <div accessory-right>
              <div class="flex items-center justify-center">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M10.6711 3.98236C10.6711 1.96689 9.03757 0.333344 7.0221 0.333344C5.00663 0.333344 3.37308 1.96689 3.37308 3.98236C3.37308 4.08514 3.37308 4.48775 3.37308 4.59053C3.37308 6.606 5.00663 8.23954 7.0221 8.23954C9.03757 8.23954 10.6711 6.606 10.6711 4.59053C10.6711 4.48775 10.6711 4.08514 10.6711 3.98236ZM13.4839 12.0628C12.5844 10.8939 9.45721 9.57534 7.02088 9.57534C4.58456 9.57534 1.45857 10.8932 0.559085 12.0628C0.00321835 12.7859 0.532934 13.8325 1.44458 13.8325C1.44458 13.8325 11.6867 13.8325 12.5984 13.8325C13.51 13.8325 14.0398 12.7859 13.4839 12.0628Z"
                    fill="currentColor"
                  />
                </svg>
                <span class="m-l-4">{{ isConnectedRoomFull(room) ? '(Full)' : getRoomCount(room) }}</span>
              </div>
            </div>
          }
        </app-select-option>
      }
    </app-select>
  </div>
}
